import { type FC, useMemo } from 'react';

import { Select, type SelectProps } from '@/components/common/select/Select';
import {
  type RevenueChartComparisonOption,
  useFormatRevenueChartComparison,
} from '@/hooks/use-format-revenue-chart-comparison';

import { DashboardV2ComparisonMode } from '../../../../../generated/graphql';

const COMPARISON_MODES = [
  DashboardV2ComparisonMode.PreviousPeriod,
  DashboardV2ComparisonMode.PreviousYear,
] as const satisfies readonly RevenueChartComparisonOption[];

type RevenueChartComparisonSelectProps = Omit<SelectProps<RevenueChartComparisonOption>, 'options'>;

export const RevenueChartComparisonSelect: FC<RevenueChartComparisonSelectProps> = (props) => {
  const formatComparison = useFormatRevenueChartComparison();

  const options = useMemo(
    () =>
      COMPARISON_MODES.map((mode) => ({
        node: formatComparison(mode),
        value: mode,
      })),
    [formatComparison]
  );

  return <Select options={options} {...props} />;
};
